import * as React from "react";
import { MARKETING_URL } from "../../../envVariables";
import { CreateAccount } from "./createAccount";
import { useAppSelector } from "../../../store/hooks";

interface Props {
  awsAccountId: string;
  providerId: string;
  customerIdentifier: string;
}
export const Registration: React.FC<Props> = ({ awsAccountId, providerId, customerIdentifier }) => {
  const theme = useAppSelector((state) => state.theme.theme);

  return (
    <div style={{ minWidth: 500, maxWidth: 800 }}>
      <div className="w-full flex justify-center mb-8">
        <a href={`${MARKETING_URL}`} target={"_blank"} rel={`noopener`} style={{ width: 300, height: 110 }}>
          <img
            className="controlplane-logo"
            height={"auto"}
            src={`/resources/logos/controlPlaneLogo${theme === "dark" ? "White" : ""}.svg`}
            alt="Control Plane Logo"
          />
        </a>
      </div>
      <div className="font-semibold text-lg mb-4">Create a Billing Account</div>
      <CreateAccount providerId={providerId} awsAccountId={awsAccountId} customerIdentifier={customerIdentifier} />
    </div>
  );
};
